export default "__VITE_ASSET__BCMWmFOY__"